const state = {
  summary: {},
  request: {},
  timecard: {},
  employee: {},
  paid_holiday: {},
};

const mutations = {
  setSummary(state, value) {
    state.summary = { ...value };
  },
  setRequest(state, value) {
    state.request = { ...value };
  },
  setTimecard(state, value) {
    state.timecard = { ...value };
  },
  setEmployee(state, value) {
    state.employee = { ...value };
  },
  setPaidHoliday(state, value) {
    state.paid_holiday = { ...value };
  },
};

const getters = {
  summary: (state) => {
    return state.summary;
  },
  request: (state) => {
    return state.request;
  },
  timecard: (state) => {
    return state.timecard;
  },
  employee: (state) => {
    return state.employee;
  },
  paid_holiday: (state) => {
    return state.paid_holiday;
  },
};

const actions = {
  setSummary({ commit }, value) {
    commit("setSummary", value);
  },
  setRequest({ commit }, value) {
    commit("setRequest", value);
  },
  setTimecard({ commit }, value) {
    commit("setTimecard", value);
  },
  setEmployee({ commit }, value) {
    commit("setEmployee", value);
  },
  setPaidHoliday({ commit }, value) {
    commit("setPaidHoliday", value);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
